export interface CarouselDataObj {
  img: string;
  imgAlt: string;
}

export const clamshellImages: CarouselDataObj[] = [
  {
    img: "./assets/images/product-imgs/clamshell1.jpg",
    imgAlt: "vegetables in clamshells",
  },
  {
    img: "./assets/images/product-imgs/clamshell2.jpg",
    imgAlt: "cakes and pies in clamshells",
  },
  {
    img: "./assets/images/product-imgs/clamshell3.jpg",
    imgAlt: "cookies in clamshells",
  },
  {
    img: "./assets/images/product-imgs/clamshell4.JPG",
    imgAlt: "triangle-shaped clamshell",
  },
  {
    img: "./assets/images/product-imgs/clamshell5.JPG",
    imgAlt: "pet recycle",
  },
];

export const labelImages: CarouselDataObj[] = [
  {
    img: "./assets/images/product-imgs/labels1.jpg",
    imgAlt: "labels printer machine",
  },
  {
    img: "./assets/images/product-imgs/labels2.jpg",
    imgAlt: "labels printer machine 2",
  },
];

export const tunaImages: CarouselDataObj[] = [
  {
    img: "./assets/images/product-imgs/tuna1.jpg",
    imgAlt: "fresh tuna steaks",
  },
  {
    img: "./assets/images/product-imgs/tuna2.jpg",
    imgAlt: "tuna sashimi",
  },
  {
    img: "./assets/images/product-imgs/tuna3.jpg",
    imgAlt: "seared tuna steaks in salad",
  },
];

export const avocadoImages: CarouselDataObj[] = [
  {
    img: "./assets/images/product-imgs/guac1.jpg",
    imgAlt: "fresh avocado",
  },
  {
    img: "./assets/images/product-imgs/guac2.jpg",
    imgAlt: "fresh guacamole",
  },
  {
    img: "./assets/images/product-imgs/guac3.jpg",
    imgAlt: "packaged guacamole",
  },
];

export const veggieCansImages: CarouselDataObj[] = [
  {
    img: "./assets/images/product-imgs/can1.jpg",
    imgAlt: "chickpeas",
  },
  {
    img: "./assets/images/product-imgs/can2.jpg",
    imgAlt: "green tomato",
  },
  {
    img: "./assets/images/product-imgs/can3.jpg",
    imgAlt: "chili peppers",
  },
  {
    img: "./assets/images/product-imgs/can4.jpg",
    imgAlt: "anaheim chilli peppers",
  },
  {
    img: "./assets/images/product-imgs/can5.jpg",
    imgAlt: "hominy corn",
  },
];

export const furnitureImages: CarouselDataObj[] = [
  {
    img: "./assets/images/product-imgs/furniture1.jpg",
    imgAlt: "chickpeas",
  },
  {
    img: "./assets/images/product-imgs/furniture2.jpg",
    imgAlt: "green tomato",
  },
  {
    img: "./assets/images/product-imgs/furniture3.jpg",
    imgAlt: "chili peppers",
  },
];

export const automationImages: CarouselDataObj[] = [
  {
    img: "./assets/images/product-imgs/automation1.jpg",
    imgAlt: "chickpeas",
  },
  {
    img: "./assets/images/product-imgs/automation2.jpg",
    imgAlt: "green tomato",
  },
  {
    img: "./assets/images/product-imgs/automation3.jpg",
    imgAlt: "chili peppers",
  },
];
